import PropTypes from 'prop-types';
import React from 'react';
import { Text, Card } from '@chakra-ui/react';

function CTACard({ title, actionLabel, onClick }) {
  return (
    <Card
      h="full"
      w="full"
      bgGradient="linear(to-bl, gray.200, gray.100)"
      justifyContent="end"
      p={10}
      onClick={onClick}
    >
      <Text fontSize="3xl" fontWeight="bold" my="0">
        {title}
      </Text>
      <Text m="0">{actionLabel}</Text>
    </Card>
  );
}

CTACard.defaultProps = {
  onClick: () => {},
};

CTACard.propTypes = {
  title: PropTypes.string.isRequired,
  actionLabel: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

export default CTACard;
